export { };

/**
 * Прелоадер для блока.
 * Тут все обработчики для них.
 */

$(window).on('preloader:hide', function (event, container)
{
    const $activeOverlays = $(container).find('.box-circle-preloader__overlay-active');

    if (!$activeOverlays.length) {
        return;
    }

    $activeOverlays.removeClass('box-circle-preloader__overlay-active');
});

$(window).on('preloader:show', function (event, container)
{
    const $overlays = $(container).find('.box-circle-preloader__overlay');

    if (!$overlays.length) {
        return;
    }

    $overlays.addClass('box-circle-preloader__overlay-active');
});


// WEBPACK FOOTER //
// ./js/main/module/box-circle-preloader.js